import { Text, VStack } from "@chakra-ui/react";
import { useGetDailyRVUTracker } from "../../../api/StudyApi";
import { StyledTable } from "../../../components/StyledTable/StyledTable";
import { DailyRVUStat } from "../../../types/DailyRVUStat";
import DailyRVURow from "./DailyRVURow";
import { HeaderCell } from "./HeaderCell";
import { useMemo } from "react";

interface Props {
  groupId?: string;
  date: Date;
}

export const DailyRVUTable: React.FC<Props> = ({ groupId, date }) => {
  const { data, isLoading } = useGetDailyRVUTracker(date, groupId);

  const filteredData = useMemo(() => {
    return data?.docs.filter((doc) => doc.totalRVUs > 0 || doc.totalCYRVUs > 0) ?? [];
  }, [data?.docs]);

  const createLegendLabel = (label: string, color: string) => {
    return (
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <span style={{ marginRight: "8px" }}>{label}</span>
        <div
          style={{
            width: "12px",
            height: "12px",
            backgroundColor: color,
            borderRadius: "50%",
          }}
        />
      </div>
    );
  };

  const tableColumns: HeaderCell[] = [
    { key: "name", label: "Provider" },
    {
      key: "totalCYRVUs",
      label: createLegendLabel("LnQ RVUs", "rgba(247, 227, 118, 1)"),
    },
    {
      key: "totalRVUs",
      label: createLegendLabel("RVUs", "#FF9760"),
    },
    {
      key: "totalStudies",
      label: createLegendLabel("Studies", "rgba(145, 182, 254, 1)"),
    },
    {
      key: "unmappedStudies",
      label: createLegendLabel("Unmapped Studies", "#FEC0A8"),
    },
  ];

  const dailyRVURow = (dailyRVUStat: DailyRVUStat) => <DailyRVURow {...dailyRVUStat} />;

  return (
    <>
      <StyledTable
        columns={tableColumns}
        data={filteredData}
        customRowRenderers={dailyRVURow}
        loading={isLoading}
        backgroundColor="transparent"
        rowHeight={18}
        size="xs"
      />
      <VStack align="flex-start" spacing={2}>
        <Text textStyle="bodyBold" color="white">
          LnQ RVU&apos;s {data?.groupTotalCYRVUs.toFixed(2) ?? 0}
        </Text>
        <Text textStyle="bodyBold" color="white">
          Total Group RVU&apos;s {data?.groupTotalRVUs.toFixed(2) ?? 0}
        </Text>
      </VStack>
    </>
  );
};
